
import { normalizeClusters } from "~/utils/branch-offices";
import { loadInformationPage, informationPageHead } from "~/utils/information-page";

export default {
    components: {
        Breadcrumbs: () => import("~/components/global/Breadcrumbs"),
        PageContent: () => import("~/components/branch_offices/PageContent"),
    },
    async asyncData(context) {
        return loadInformationPage(context, {
            endpoint: "web/page/branch-offices/all",
            title: "Branch Offices",
            validate: (content) => typeof content.title === "string" && Array.isArray(content.branches) && normalizeClusters(content.clusters).length > 0,
        });
    },
    mounted() {
        this.scrollToTop();
    },
    head() {
        return informationPageHead(this.$route, "Branch Offices", "Find a Malayan Insurance branch office by city or province and explore its location on the map.");
    },
};
